export const DAY_CODES = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;

export type DayCode = (typeof DAY_CODES)[number];

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri'] as const satisfies readonly DayCode[];

export const WEEKEND = ['sat', 'sun'] as const satisfies readonly DayCode[];

export const DAY_NAMES: Record<DayCode, string> = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
};

/** Deduplicated, in week order, unknown values dropped. */
export const sortDays = (days: readonly unknown[]): DayCode[] =>
  DAY_CODES.filter((day) => days.includes(day));

const sameDays = (a: readonly DayCode[], b: readonly DayCode[]) =>
  a.length === b.length && a.every((day) => b.includes(day));

/** Shared by the applied-filter chip and the table's "Runs on" column, so they can't drift. */
export const formatDays = (days: readonly DayCode[]): string => {
  const sorted = sortDays(days);

  if (sorted.length === 1) return DAY_NAMES[sorted[0]];
  if (sorted.length === DAY_CODES.length) return 'Every day';
  if (sameDays(sorted, WEEKDAYS)) return 'Weekdays';
  if (sameDays(sorted, WEEKEND)) return 'Weekend';

  return sorted.map((day) => DAY_NAMES[day].slice(0, 3)).join(', ');
};
